module.exports = __webpack_public_path__ + "static/media/image_5.fef5d553.svg";